const displayMinutes = (initialMinutes = 0, displayHour = "h", displayMinute = "m") => {
  if (!initialMinutes)
    return "0h";
  const hoursNum = Math.floor(initialMinutes / 60);
  const hours = hoursNum.toString();
  const minutes = (initialMinutes % 60).toString();
  const separator = hours.length > 0 && minutes.length > 0 ? " " : "";
  if (hours === "0" && minutes === "0")
    return "0h";
  if (minutes === "0")
    return `${hours}${displayHour}`;
  const hoursToShow = hoursNum > 0 ? `${hours}${displayHour}${separator}` : "";
  return `${hoursToShow}${minutes}${displayMinute}`;
};
export {
  displayMinutes
};
